"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebPImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const WebPImage_module_css_1 = __importDefault(require("./WebPImage.module.css"));
/**
 * Generic WebPImage component.
 * Inspired from https://www.joshwcomeau.com/performance/embracing-modern-image-formats/
 */
function WebPImage({ webpUrl, fallbackUrl, imgProps, pictureProps, sourceProps }) {
    const pictureClassName = pictureProps?.className ?? "";
    return ((0, jsx_runtime_1.jsxs)("picture", { ...(pictureProps ?? {}), className: (0, clsx_1.default)(WebPImage_module_css_1.default.image, pictureClassName), children: [(0, jsx_runtime_1.jsx)("source", { type: "image/webp", srcSet: webpUrl, ...(sourceProps ?? {}) }), (0, jsx_runtime_1.jsx)("img", { srcSet: fallbackUrl || webpUrl, ...(imgProps ?? {}) })] }));
}
exports.WebPImage = WebPImage;
//# sourceMappingURL=WebPImage.js.map